/* ============
 * City Transformer
 * ============
 */

import Transformer from './transformer';

export default class WarehouseContactTransformer extends Transformer {

  static fetch(item) {
    return {
      id: item.id,
      firstName: item.firstName,
      lastName: item.lastName,
      email: item.email,
      phoneNumber: item.phoneNumber,
      warehouseId: item.warehouse_id,
    };
  }

  static send(item) {
    return {
      first_name: item.firstName,
      last_name: item.lastName,
      email: item.email,
      phone_number: item.phoneNumber,
      warehouse_id: item.warehouseId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/warehouseContact.js